import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import GlobalStyle from "./scripts/globalStyle";
import "rsuite/dist/rsuite-rtl.min.css"; //------ rsuite css ------\\
import Store from "./redux/store";
import { Provider } from "react-redux";

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
      <React.StrictMode>
        <GlobalStyle />
        <Switch>
          <Route exact path="/" component={App} />
          <Redirect path="*" to="/" />
        </Switch>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
